import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {Link, useNavigate, useParams} from "react-router-dom";
import styled from "styled-components";
import { getForIndividualsComment,updateForIndividualsComment, createForIndividualsComment } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import FormGroup from "../../Common/FormGroup";
import { Formik } from "formik";
import * as Yup from "yup";

// Validation Schema
const validationSchema = Yup.object({
  owner_name1: Yup.string()
    .required("Owner name 1 is required"),
  comment1: Yup.string()
    .required("Comment 1 is required"),
  owner_name2: Yup.string()
    .required("Owner name 2 is required"),
  comment2: Yup.string()
    .required("Comment 2 is required"),
  owner_name3: Yup.string()
    .required("Owner name 3 is required"),
  comment3: Yup.string()
    .required("Comment 3 is required"),
  owner_name4: Yup.string()
    .required("Owner name 4 is required"),
  comment4: Yup.string()
    .required("Comment 4 is required"),
});

export default function EditComments() {
  const { partnerId, id } = useParams();

  const [data, setComment] = useState({
    owner_name1: "",
    comment1: "",
    owner_name2: "",
    comment2: "",
    owner_name3: "",
    comment3: "",
    owner_name4: "",
    comment4: "",
    index: null,
  });

  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const getInitialValues = () => ({
    owner_name1: data.owner_name1 || "",
    comment1: data.comment1 || "",
    owner_name2: data.owner_name2 || "",
    comment2: data.comment2 || "",
    owner_name3: data.owner_name3 || "",
    comment3: data.comment3 || "",
    owner_name4: data.owner_name4 || "",
    comment4: data.comment4 || "",
  });

  const fetchCommentData = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    try {
      const res = await getForIndividualsComment(id);
      console.log(res);
      setComment(res.data.data[0]);
    } catch (error) {
      console.log(error);
      showToast({
        type: 'error',
        message: error?.response?.data?.message || "Failed to fetch comments data. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };
  
useEffect(() => {
  fetchCommentData();
}, [id]);

const handleSubmit = async (values) => {
  setSaving(true);

  const formData = {
    owner_name1: values.owner_name1,
    comment1: values.comment1,
    owner_name2: values.owner_name2,
    comment2: values.comment2,
    owner_name3: values.owner_name3,
    comment3: values.comment3,
    owner_name4: values.owner_name4,
    comment4: values.comment4,
  };

  try {
    if (!Number(id)) {
      formData.partner_id = partnerId;
      const res = await createForIndividualsComment(formData);
      if (res.status === 200) {
        showToast({
          type: 'success',
          message: res?.data?.message || 'Comments section has been created successfully!',
        });
        const commentData = res.data.data;
        setComment(commentData);
        if (commentData && commentData.id) {
          navigate(`/${partnerId}/forindividuals/comments/edit/${commentData.id}`);
        }
      } else {
        showToast({
          type: 'error',
          message: res?.data?.message || 'Failed to create comments section. Please try again.',
        });
      }
    } else {
      const res = await updateForIndividualsComment(id, formData);
      if (res.status === 200) {
        showToast({
          type: 'success',
          message: res?.data?.message || 'Comments section has been updated successfully!',
        });
        console.log(res.data);
        setComment(res.data.data);
      } else {
        showToast({
          type: 'error',
          message: res?.data?.message || 'Failed to update comments section. Please try again.',
        });
      }
    }
  } catch (err) {
    console.log(err);
    showToast({
      type: 'error',
      message: err?.response?.data?.message || 'Failed to update comments section. Please try again.',
    });
  } finally {
    setSaving(false);
  }
};

  return (
    <>
      {isLoading ? <CmsCircularProgress /> :
        <FormWrapper>
          <Title>{Number(id) ? 'Edit' : 'Add'} Comments Section</Title>
          <SliderDiv>
            <Formik
              initialValues={getInitialValues()}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({
                values,
                errors,
                touched,
                handleSubmit,
                getFieldProps,
                isSubmitting,
              }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  {/* Comment 1 */}
                  <SubTitle>Comment 1</SubTitle>
                  <FormGroup 
                    label="Enter an Owner's name" 
                    requiredField
                    error={touched.owner_name1 && errors.owner_name1 ? errors.owner_name1 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={2}
                      {...getFieldProps('owner_name1')}
                      placeholder="Enter owner name here..."
                      isInvalid={touched.owner_name1 && !!errors.owner_name1}
                    />
                  </FormGroup>
                  <FormGroup 
                    label="Enter a new comment" 
                    requiredField
                    error={touched.comment1 && errors.comment1 ? errors.comment1 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={3}
                      {...getFieldProps('comment1')}
                      placeholder="Enter comment here..."
                      isInvalid={touched.comment1 && !!errors.comment1}
                    />
                  </FormGroup>

                  {/* Comment 2 */}
                  <SubTitle className="mt-3">Comment 2</SubTitle>
                  <FormGroup 
                    label="Enter an Owner's name" 
                    requiredField
                    error={touched.owner_name2 && errors.owner_name2 ? errors.owner_name2 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={2}
                      {...getFieldProps('owner_name2')}
                      placeholder="Enter owner name here..."
                      isInvalid={touched.owner_name2 && !!errors.owner_name2}
                    />
                  </FormGroup>
                  <FormGroup 
                    label="Enter a new comment" 
                    requiredField
                    error={touched.comment2 && errors.comment2 ? errors.comment2 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={3}
                      {...getFieldProps('comment2')}
                      placeholder="Enter comment here..."
                      isInvalid={touched.comment2 && !!errors.comment2}
                    />
                  </FormGroup>

                  {/* Comment 3 */}
                  <SubTitle className="mt-3">Comment 3</SubTitle>
                  <FormGroup 
                    label="Enter an Owner's name" 
                    requiredField
                    error={touched.owner_name3 && errors.owner_name3 ? errors.owner_name3 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={2}
                      {...getFieldProps('owner_name3')}
                      placeholder="Enter owner name here..."
                      isInvalid={touched.owner_name3 && !!errors.owner_name3}
                    />
                  </FormGroup>
                  <FormGroup 
                    label="Enter a new comment" 
                    requiredField
                    error={touched.comment3 && errors.comment3 ? errors.comment3 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={3}
                      {...getFieldProps('comment3')}
                      placeholder="Enter comment here..."
                      isInvalid={touched.comment3 && !!errors.comment3}
                    />
                  </FormGroup>

                  {/* Comment 4 */}
                  <SubTitle className="mt-3">Comment 4</SubTitle>
                  <FormGroup 
                    label="Enter an Owner's name" 
                    requiredField
                    error={touched.owner_name4 && errors.owner_name4 ? errors.owner_name4 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={2}
                      {...getFieldProps('owner_name4')}
                      placeholder="Enter owner name here..."
                      isInvalid={touched.owner_name4 && !!errors.owner_name4}
                    />
                  </FormGroup>
                  <FormGroup 
                    label="Enter a new comment" 
                    requiredField
                    error={touched.comment4 && errors.comment4 ? errors.comment4 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={3}
                      {...getFieldProps('comment4')}
                      placeholder="Enter comment here..."
                      isInvalid={touched.comment4 && !!errors.comment4}
                    />
                  </FormGroup>

                  <ButtonWrapper className="mt-3">
                    <Link to={`/${partnerId}/forindividuals/comments/view/${id}`}>
                      <Button variant="secondary" className="w-100">Go Back</Button>
                    </Link>
                    <Button 
                      variant="primary"
                      type="submit"
                      disabled={saving || isSubmitting}
                      className="w-100"
                    >
                      {saving ? "Saving..." : "Save Changes"}
                    </Button>
                  </ButtonWrapper>
                </Form>
              )}
            </Formik>
          </SliderDiv>
        </FormWrapper>
      }
    </>
  );
}

const FormWrapper = styled.div`
  @media (min-width:576px) {
    padding: 1rem;
  }
  @media (min-width:768px) {
    padding: 1.5rem;
  }
  padding: .5rem;
`;

const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const SubTitle = styled.h5``;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  @media (max-width: 890px) {
    gap: 2rem;
  }
  @media (max-width: 425px) {
    gap: 1rem;
  }
`;